/**
 * Represents the accuracy level of location services
 */
export type LocationAccuracy = 'best' | 'high' | 'medium' | 'low' | 'reduced';
